// extracted by mini-css-extract-plugin
export default {"root":"MessageBox-root-b28305d22e3be962f719464e59a24cc0"};